import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { AskUserQuestionInputSchema } from "@app/lib/actions/types";

export const ASK_USER_QUESTION_TOOL_NAME = "ask_user_question" as const;

export const ASK_USER_QUESTION_TOOLS_METADATA = [
  {
    name: ASK_USER_QUESTION_TOOL_NAME,
    description:
      "Ask the user a question while you work. Ask only when one of these holds:\n" +
      "- A fact you need is missing, would change what you produce, and no tool, the conversation, the " +
      'user\'s context or their data supplies it. Example: "Which time zone should I schedule this in?" ' +
      "when nothing says.\n" +
      "- You are about to take an irreversible or outward action (sending, posting, deleting, paying) and " +
      'its target or scope is unclear. Example: "Send this to the whole team or just the manager?"\n\n' +
      "Otherwise decide yourself: take the option you would recommend, say it in one line, and do the " +
      "work; the user can redirect you at any time. Never ask permission to start or continue work the " +
      "user asked for, to confirm a choice the evidence already makes, or to approve your approach.\n\n" +
      "Important notes:\n" +
      "- The user always gets an automatic option for free-text input\n" +
      "- Use multiSelect: true to allow multiple answers to be selected for a question\n" +
      "- Put up to two more related questions in additionalQuestions so the user answers them on one card; " +
      "never call this tool twice in one step\n" +
      '- If a specific option is recommended, it should be the first option in the list and have "(Recommended)" ' +
      "at the end of its label",
    schema: {
      ...AskUserQuestionInputSchema.shape,
    },
    enableAlerting: true,
    stake: "never_ask",
    eager: true,
    displayLabels: {
      running: "Asking user...",
      done: "User answered",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const ASK_USER_QUESTION_SERVER = {
  serverInfo: {
    name: "ask_user_question",
    version: "1.0.0",
    description: "Ask the user a question with multiple-choice options.",
    icon: "ActionChatBubbleThoughtIcon",
    authorization: null,
    documentationUrl: null,
  },
  tools: ASK_USER_QUESTION_TOOLS_METADATA,
} as const satisfies ServerMetadata;
